<template>
  <v-card v-if="!noCard" border color="grey-lighten-5">
    <v-card-text>
      <div class="d-flex align-center justify-space-between">
        <div class="d-flex align-center ga-3">
          <div class="icon--blue" style="height: 30px; width: 30px">
            <v-icon icon="mdi-file-outline" size="small"></v-icon>
          </div>

          <span class="font-weight-bold font-size-13">
            {{ label }}
          </span>

          <v-chip v-if="fileCount" color="blue-darken-3" size="x-small">
            <span class="font-weight-bold">{{ fileCount }}</span>
          </v-chip>
        </div>
        <div class="d-flex align-center ga-2">
          <v-btn
            :disabled="disabled"
            :loading="loading"
            :readonly="readonly"
            border
            color="white"
            density="comfortable"
            @click.stop="handleSelect">
            <div class="font-size-12">
              <v-icon class="mr-1">mdi-plus</v-icon>
              <span class="font-weight-medium">Додати</span>
            </div>
          </v-btn>

          <v-btn
            v-if="fileCount"
            :icon="isOpen ? 'mdi-chevron-up' : 'mdi-chevron-down'"
            border
            color="white"
            density="comfortable"
            size="small"
            @click="toggle">
          </v-btn>
        </div>
      </div>
    </v-card-text>
    <v-expand-transition>
      <div v-show="isOpen">
        <v-card-text class="bg-white">
          <slot name="files"></slot>
        </v-card-text>
      </div>
    </v-expand-transition>
  </v-card>

  <div v-else>
    <div class="d-flex align-center justify-space-between mb-2">
      <v-btn
        :disabled="disabled"
        :loading="loading"
        :readonly="readonly"
        color="primary"
        density="comfortable"
        size="x-small"
        variant="outlined"
        @click="handleSelect">
        <v-icon class="mr-1">mdi-paperclip</v-icon>
        {{ label }}
      </v-btn>

      <slot v-if="$slots['append-action']" name="append-action" />
    </div>

    <slot name="files"></slot>
  </div>
</template>

<script lang="ts">
import { PropType, ref, watch } from 'vue'
import { selectFile } from '@/components/filesUploader/selectFile'
import { SelectFileOptions } from '@/components/filesUploader/selectFile/types'

export default {
  name: 'FileList',
  emits: ['select'],
  props: {
    label: { type: [String, Boolean] },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    noCard: { type: Boolean },
    loading: {
      type: Boolean,
      default: false,
    },
    fileCount: {
      type: Number,
      default: 0,
    },
    selectOptions: {
      type: Object as PropType<SelectFileOptions>,
    },
  },
  setup(props, { emit }) {
    const isOpen = ref(false)

    const toggle = () => {
      isOpen.value = !isOpen.value
    }

    watch(
      () => props.fileCount,
      val => {
        if (val) isOpen.value = true
      }
    )

    const handleSelect = () => {
      if (!props.loading) {
        selectFile(props.selectOptions).then(result => {
          emit('select', result)
        })
      }
    }

    return {
      handleSelect,
      isOpen,
      toggle,
    }
  },
}
</script>

<style lang="scss" scoped>
.rotate {
  transform: rotate(180deg);
  transition: 0.2s;
}

.v-icon {
  transition: 0.2s;
}
</style>
